import React, { useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { base64DecodeToJson } from 'common/utilities/utils';
import { getAppUpdateContentAction } from '@kfc-global/react-shared/redux/Actions/AppUpdateActions';
import { getCmsClient } from 'common/utilities/cmsClient';

import queryString from 'query-string';
import { isEmpty, filter } from 'lodash';

import AppUpdate from 'organisms/AppUpdate/Presentation/AppUpdate';
import SharedConstants from 'common/constants/SharedConstants';

const STORE_LINKS = {
  APP_STORE: 'AppStore',
  PLAY_STORE: 'PlayStore',
};

export const AppUpdateContainer = props => {
  const { history } = props;
  const [appOsType, setAppOsType] = useState(null);
  const dispatch = useDispatch();
  const { appUpdateContent } = useSelector(data => {
    return {
      appUpdateContent: data?.appUpdateReducer?.response || null,
    };
  });

  const onUpdateButtonClick = () => {
    const dictionaryData = { key: 'OpenInBrowser', value: '' };

    const appStoreContent = filter(appUpdateContents, {
      contentType: SharedConstants.CMS_CONTENT_TYPES.NAVIGATION_LINK,
      storeLinkId: 'iOS' === appOsType ? STORE_LINKS.APP_STORE : STORE_LINKS.PLAY_STORE,
    });
    dictionaryData.value = appStoreContent[0].storeUrl;

    const payload = JSON.stringify(dictionaryData);
    window.sendToMobile(appOsType, payload);
  };

  const appUpdateContents = appUpdateContent?.headerData?.body?.map(data => {
    let contents = {};
    const contentType = data?.sys?.contentType?.sys?.id;
    if (SharedConstants.CMS_CONTENT_TYPES.LOGO_ICON === contentType) {
      contents = {
        contentType,
        className: data?.fields?.category,
        imgSrc: data?.fields?.mobileImage?.fields?.file?.url,
        altTxt: data?.fields?.altText,
      };
    }

    if (SharedConstants.CMS_CONTENT_TYPES.MULTI_TEXT === contentType) {
      contents = { contentType, txts: data?.fields?.listText };
    }

    if (SharedConstants.CMS_CONTENT_TYPES.CALL_TO_ACTION === contentType) {
      contents = {
        contentType,
        txt: data?.fields?.buttonText,
        onClickHandler: onUpdateButtonClick,
      };
    }

    if (SharedConstants.CMS_CONTENT_TYPES.NAVIGATION_LINK === contentType) {
      const storeUrl = data?.fields?.externalurl;
      const storeLinkId = data?.fields?.linkId;
      contents = { contentType, storeUrl, storeLinkId };
    }

    return contents;
  });

  const navigateToHome = useCallback(() => {
    history.push({
      pathname: '/',
    });
  }, [history]);

  useEffect(() => {
    const urlParams = queryString.parse(props.location.search);
    if (isEmpty(urlParams?.appurl)) {
      navigateToHome();
    } else {
      const { DeviceId, DeviceType } = base64DecodeToJson(urlParams?.appurl);
      if (!DeviceId) {
        navigateToHome();
      }
      setAppOsType(DeviceType);
    }
  }, [navigateToHome, props.location.search]);

  useEffect(() => {
    dispatch(
      getAppUpdateContentAction({
        object: getCmsClient(),
        contentFull: {
          content_type: 'appUpdate',
          'fields.updateStatus': 'major',
          include: 5,
        },
      }),
    );
  }, [dispatch]);

  return (
    <>
      <AppUpdate appUpdateContents={appUpdateContents} />
    </>
  );
};
